<template>
  <div class="mt-5 sm-mt-2">
    <div class="home-footer">
      <b-row
        v-for="mMenu in menus.filter((menus) => menus.name === 'Footer')"
        :key="mMenu.priority"
        class="text-right"
      >
        <b-col cols="12" lg="3" class="footer-logo">
          <b-row class="align-items-center justify-content-center sm-logo mt-5">
            <b-col cols="12" class="text-center">
              <img
                class="p-contain"
                :src="config.secondLogoAddress"
                width="150px"
                alt="logo"
              />
            </b-col>
            <b-col cols="12" class="pe-3 text-center mt-4">
              <h3 class="text-p-white">
                {{ config.title }}
              </h3>
            </b-col>
            <b-col cols="12" class="mt-3">
              <b-row
                class="align-items-center justify-content-center social-network"
              >
                <b-col
                  v-for="social in socials"
                  :key="social.id"
                  cols="auto"
                  class="text-center px-2 mb-2 mt-3"
                >
                  <div v-if="social.id === 1" class="social-footer">
                    <a
                      :href="social.link"
                      class="icon-instagram text-p-white p-fs-xxh"
                    ></a>
                  </div>
                  <div class="social-footer" v-if="social.id === 2">
                    <a
                      :href="social.link"
                      class="icon-telegram text-p-white p-fs-xxh"
                    ></a>
                  </div>
                  <div class="social-footer" v-if="social.id === 3">
                    <a
                      :href="social.link"
                      class="icon-whatsapp text-p-white p-fs-xxh"
                    ></a>
                  </div>
                  <div class="social-footer" v-if="social.id === 4">
                    <a
                      :href="social.link"
                      class="icon-twitter text-p-white p-fs-xxh"
                    ></a>
                  </div>
                  <div class="social-footer" v-if="social.id === 5">
                    <a
                      :href="social.link"
                      class="icon-facebook text-p-white p-fs-xxh"
                    ></a>
                  </div>
                  <div class="social-footer" v-if="social.id === 6">
                    <a
                      :href="social.link"
                      class="icon-youtube text-p-white p-fs-t"
                    ></a>
                  </div>
                  <div class="social-footer" v-if="social.id === 7">
                    <a
                      :href="social.link"
                      class="icon-linkedin text-p-white p-fs-t"
                    ></a>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <hr class="hide-desktop footer-line" />
        <b-col cols="12" lg="4" class="pt-5 mt-3 sm-pt-0">
          <b-row>
            <b-col cols="12" lg="6" md="3">
              <b-row>
                <b-col cols="1" class="mt-2 ms-1">
                  <b-icon
                    icon="telephone"
                    scale="1.3"
                    class="text-p-second"
                  ></b-icon>
                </b-col>
                <b-col cols="10">
                  <p class="p-fs-s mb-0 p-fw-normal">شماره تماس</p>
                  <p class="p-fs-m mt-1">{{ config.tel }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" md="3">
              <b-row>
                <b-col cols="1" class="mt-2 ms-1">
                  <b-icon
                    icon="envelope"
                    scale="1.3"
                    class="text-p-second"
                  ></b-icon>
                </b-col>
                <b-col cols="10">
                  <p class="p-fs-s mb-0 p-fw-normal">پست الکترونیک</p>
                  <p class="p-fs-m mt-1">{{ config.email }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="12" md="6" class="mt-2">
              <b-row>
                <b-col cols="1" class="mt-2 ms-1">
                  <b-icon
                    icon="geo-alt"
                    scale="1.3"
                    class="text-p-second"
                  ></b-icon>
                </b-col>
                <b-col cols="10" class="pe-0">
                  <p class="p-fs-s mb-0 p-fw-normal">آدرس</p>
                  <p class="p-fs-m mt-1">{{ config.address }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <hr class="hide-des-md footer-line" />
        <b-col
          cols="12"
          lg="2"
          md="4"
          class="mt-5 sm-mt-2 menu-md me-lg-5 pe-lg-5"
        >
          <div v-for="menu in mMenu.children" :key="menu.id">
            <b-icon icon="chevron-left" scale="0.7" class="text-p-second"></b-icon>

            <b-button :to="menu.link" class="footer-link p-fs-l p-lh-l me-1">
              {{ menu.text }}
            </b-button>
            <!-- <b-button
              v-for="child in menu.children"
              :key="child.id"
              :to="child.link"
              class="footer-link p-fs-l p-lh-l"
              @click="routeLink(child)"
            >
              {{ child.text }}
            </b-button> -->
          </div>
        </b-col>
        <hr class="hide-des-md footer-line" />

        <b-col cols="12" lg="2" md="8" class="mt-5 sm-my-4 email-box">
          <h4 class="p-fs-xxl text-center text-p-white">
            همیشه اولین نفر باشید!
          </h4>
          <div class="mt-3">
            <b-form-input
              id="email"
              class="input p-fs-m text-center"
              size="lg"
              :placeholder="label.form.emailOrMobile"
              v-model="form.input"
              @keyup.enter="addSubscriber"
            ></b-form-input>
          </div>
          <div class="mt-3 captch-btn">
            <b-button
              v-if="!loadingBtn"
              class="main-btn py-2 text-p-white"
              @click="addSubscriber"
            >
              {{ label.button.newsletter }}
            </b-button>
            <b-button v-else disabled class="main-btn py-2">
              <b-spinner small></b-spinner>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <hr class="hr-footer " />
      <b-row class="justify-content-center text-center mt-2 copy-right">
        <b-col cols="12" lg="6" class="align-self-center">
          <p class="align-self-center m-0 text-p-white p-fs-n p-fw-normal">
            {{ config.copyright }}
          </p>
        </b-col>

        <b-col cols="12" lg="6" class="align-self-center sm-mt-2">
          <p class="align-self-center m-0 text-p-white p-fs-n p-fw-normal">
            design and developed by
            <a href="https://parsinaco.com/" target="_blank">Parsina</a> -
            powered by PCMS v - {{ this.version }}
          </p>
        </b-col>
      </b-row>
    </div>

    <!-- Captcha Modal -->
    <b-modal
      dir="rtl"
      v-model="captchaModal"
      content-class="p-border-3"
      centered
      hide-header
      hide-footer
      size="sm"
    >
      <b-container fluid>
        <b-row class="justify-content-center">
          <b-col class="text-end pe-1 mb-1">
            <button
              class="ps-closeModalBtn"
              @click="captchaModal = false"
              v-b-tooltip.hover
              :title="label.button.closeModal"
            >
              <b-icon icon="x" scale="1.5"></b-icon>
            </button>
          </b-col>
          <b-col cols="12" class="align-self-center py-0">
            <b-row class="mt-3 mx-0 p-0 text-right">
              <b-col cols="12" class="d-flex align-items-center">
                <div class="ms-2">
                  <button id="reloadBtnTlp" @click="reloadCaptcha">
                    <b-icon
                      icon="arrow-counterclockwise"
                      scale="1.1"
                      variant="ps-tools-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    target="reloadBtnTlp"
                  >
                    باگذاری مجدد
                  </b-tooltip>
                </div>
                <img
                  :src="captcha.dntCaptchaImgUrl"
                  alt="captcha"
                  class="captcha"
                  width="80%"
                />
              </b-col>
              <b-col cols="12" class="ps-3 d-flex align-items-center mt-3">
                <label class="p-fs-m ps-2" for="name"> کد </label>
                <b-form-input
                  id="captchaCode"
                  v-model="form.captcha"
                  class="input p-fs-m text-center"
                  size="sm"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row
              class="mt-3 mx-0 p-0 text-right justify-content-end modal-captch-btn"
            >
              <b-col class="m-0" cols="12" lg="5">
                <b-button
                  class="main-btn w-100 text-p-white"
                  v-if="!loadingBtn"
                  @click="submitNewsLetter"
                >
                  {{ label.button.send }}
                </b-button>
                <b-button class="btn-p-main w-100" disabled v-if="loadingBtn">
                  <b-spinner small></b-spinner>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/plugins/StaticLabels.js";
import alert from "@/plugins/AlertMessages.js";

export default {
  name: "TheFooter",
  computed: {
    ...mapGetters({
      menus: "baseX/menus",
      socials: "baseX/socials",
      config: "baseX/config",
      loadingBtn: "loadingBtn",
      newsletterDisplay: "baseX/newsletterDisplay",
      captcha: "captcha",
      postCheck: "postCheck",
    }),
    routeName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      label,
      alert,
      mainMenus: null,
      captchaModal: null,
      version: process.env.VUE_APP_VERSION,
      form: {
        input: null,
        captcha: null,
      },
    };
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadFields();
        this.reloadCaptcha();
      }
    },
  },
  methods: {
    addSubscriber() {
      if (this.form.input) {
        this.captchaModal = true;
      } else {
        const msg = "لطفا پست الکترونیک یا شماره همراه خود را وارد کنید";
        this.$store.commit("setError", msg);
      }
      this.reloadCaptcha();
    },
    setDynamicLink(item) {
      return "/page" + item;
    },
    routeLink(menu) {
      if (menu.link.indexOf("https") === 0 || menu.link.indexOf("http") === 0) {
        window.open(menu.link, "_blank");
      } else {
        this.$router.push(menu.link);
      }
    },
    submitNewsLetter() {
      let formData = new FormData();
      if (this.form.input != null && this.form.input !== "") {
        formData.append("Input", this.form.input);
        if (this.form.captcha && this.form.captcha.length > 0) {
          formData.append("CaptchaInputText", this.form.captcha);
          formData.append("CaptchaText", this.captcha.dntCaptchaTextValue);
          formData.append("CaptchaToken", this.captcha.dntCaptchaTokenValue);
          this.$store.dispatch("baseX/sendNewsLetter", formData);
        } else {
          this.$store.commit("setError", alert.error.captcha);
        }
      } else {
        this.$store.commit("setError", alert.error.empty);
      }
    },
    reloadCaptcha() {
      this.$store.dispatch("getClientCaptcha");
      this.form.captcha = null;
    },
    reloadFields() {
      this.form.input = null;
      this.form.captcha = null;
      this.captchaModal = false;
    },
  },
  beforeCreate() {
    this.$store.dispatch("baseX/getMenus");
    this.$store.dispatch("baseX/getSocials");
  },
};
</script>
